// extracted by mini-css-extract-plugin
export var container = "layout-module--container--RoCXy";
export var content = "layout-module--content--FwTjf";